export default __webpack_public_path__ + "static/media/OpenSans-Bold.0a80ea3f.ttf";